import React from "react";
import ProjectTeamMemberForm from "./ProjectTeamMemberForm";
import { useState, useEffect } from "react";
import { getTeamMembers, addTeamMember } from "../../api/TeamMemberApi";
import { getProjectById, getProjectData } from "../../api/ProjectApi";
import { Form } from "antd";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import ProjectForm from "./ProjectForm";
import { getMemberProfiles } from "../../api/MemberProfileApi";
import { AppRoutes } from "../../AppRoutes";

const ManageProjectTeamMemberPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [projectParams] = useSearchParams();
    const projectName = projectParams.get("projectName");
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [experience, setExperience] = useState(2);
    const [searchMemberProfile, setSearchMemberProfile] = useState("");
    const [searchMemberProfileOptions, setSearchMemberProfileOptions] = useState([]);
    const [event, setEvent] = useState("");

    useEffect(() => {
        if (id == "") {
            setEvent("add");
        }
    }, []);

    useEffect(() => {
        getMemberProfileOptions()
    }, [searchMemberProfile]);

    const handleExperienceChange = async (value) => {
        await getMemberProfileOptions()
    };

    const handleCancel = () => {
        navigate(AppRoutes.projectId(id));
    };

    const handleSearchMemberProfile = (value) => {
        form.setFieldsValue({ name: value })
        if (value.length >= 1) {
            setSearchMemberProfile(value);
        } else {
            setSearchMemberProfile("")
        };
    };

    const handleSelectMemberProfile = async (value) => {
        let base64ProfileDescription = Buffer.from(value).toString('base64');
        await getMemberProfiles(base64ProfileDescription, form.getFieldValue("experience")).then(res => {
            if (res.status == 200) {
                form.setFieldsValue({ price: res.data.result[0].price })
            } else {
                AdnMessageError();
                setLoading(false);
            }
        })

        form.setFieldsValue({ name: value })
        setSearchMemberProfile(value);
    };

    const getMemberProfileOptions = async () => {
        let experienceField = form.getFieldsValue().experience
        let base64SearchMemberProfile = Buffer.from(searchMemberProfile).toString('base64');

        await getMemberProfiles(base64SearchMemberProfile, experienceField).then((res) => {
            if (res.status == 200) {
                searchMemberProfile.length >= 1
                    ? setSearchMemberProfileOptions(res.data.result)
                    : setSearchMemberProfileOptions([]);
            }
        })
    };

    const submitProjectTeamMember = (values) => {
        values.projectId = id;
        addTeamMember(values).then((res) => {
            if (res.status == 201 && res.data.success == true) {
                navigate(AppRoutes.projectId(id));
                AdnMessageSuccess();
            } else {
                AdnMessageError();
            }
        });
        setLoading(false);
    };

    return (
        <ProjectTeamMemberForm
            form={form}
            handleSearchMemberProfile={handleSearchMemberProfile}
            handleSelectMemberProfile={handleSelectMemberProfile}
            searchMemberProfileOptions={searchMemberProfileOptions}
            handleCancel={handleCancel}
            submitProjectTeamMember={submitProjectTeamMember}
            projectName={projectName}
            handleExperienceChange={handleExperienceChange}
        />
    );
};

export default ManageProjectTeamMemberPage;
